import { Users } from 'lucide-react'
import type { PipelineSplitOptionDto } from '@lib/dto/pipeline.dto'
import { FilterChip, FilterOption } from '@/components/ui/filter-chip'
import { SegmentedControl } from '@/components/ui/segmented-control'

interface SplitFilterProps {
  splits: readonly PipelineSplitOptionDto[]
  split: string
  onSplit: (split: string) => void
}

/** Short names side by side, so four fit a phone: the pipelines keep the company's own. */
const SHORT: Readonly<Record<string, string>> = { all: 'All', unlinked: 'No lead' }

/** The most splits shown side by side; a company with more pipelines picks from a menu. */
const SIDE_BY_SIDE = 4

/**
 * Which couples a pipeline counts (docs/pipeline-view.spec.md, "The split"):
 * every couple, each lead stats pipeline's (Weddings, Private events), or those
 * with no GoHighLevel lead. Side by side where they fit, as the view is, so
 * Weddings is one click away; a filter like any list's where there are more.
 */
export function SplitFilter({ splits, split, onSplit }: SplitFilterProps) {
  if (splits.length > 1 && splits.length <= SIDE_BY_SIDE) {
    return (
      <SegmentedControl
        label="Couples"
        size="sm"
        value={split}
        options={splits.map((s) => ({ value: s.value, label: SHORT[s.value] ?? s.label }))}
        onValueChange={onSplit}
      />
    )
  }
  const chosen = splits.find((s) => s.value === split)
  return (
    <FilterChip
      property="Couples"
      icon={Users}
      valueLabel={split === 'all' ? null : (chosen?.label ?? null)}
      onClear={() => onSplit('all')}
    >
      {(close) =>
        splits.map((s) => (
          <FilterOption
            key={s.value}
            selected={s.value === split}
            onSelect={() => {
              onSplit(s.value)
              close()
            }}
          >
            {s.label}
          </FilterOption>
        ))
      }
    </FilterChip>
  )
}
